import React from "react";
import { useModal } from "react-modal-hook";
import { CommonModal } from "../../../Common/CommonModal";
import Modal from "../../../Common/Modal";
import { Body } from "../../../Common/Typography";
import {
  ValidationErrorDescription,
  ValidationErrorEmpty,
  ValidationErrorItem,
  ValidationErrorList,
} from "./SubmissionsBuilder/__styles__/ValidationErrorModal";

export const ValidationErrorModalContent = ({
  validationErrors,
  onClose,
}: {
  validationErrors?: { path: string; message: string }[];
  onClose: () => void;
}) => {
  return (
    <CommonModal
      title="Form Validation Errors"
      size="medium"
      onCancel={onClose}
      secondaryButtons={[
        {
          text: "Copy to Clipboard",
          onClick: () => {
            const errorText = validationErrors
              ?.map(e => `Field: ${e.path || "root"}\nError: ${e.message}`)
              .join("\n\n");
            void navigator.clipboard.writeText(errorText || "");
          },
        },
      ]}
      content={
        <>
          <ValidationErrorDescription>
            The form cannot be saved due to the following validation errors:
          </ValidationErrorDescription>
          {validationErrors && validationErrors.length > 0 ?
            <ValidationErrorList>
              {validationErrors.map((error, index) => (
                <ValidationErrorItem key={index}>
                  <Body size="small" type="regular" color="contentPrimary">
                    Field: {error.path || "root"}
                  </Body>
                  <Body size="small" type="regular" color="contentPrimary">
                    Error: {error.message}
                  </Body>
                </ValidationErrorItem>
              ))}
            </ValidationErrorList>
          : <ValidationErrorEmpty>
              No validation errors found.
            </ValidationErrorEmpty>
          }
        </>
      }
    />
  );
};

export const useValidationErrorModal = (
  validationErrors?: { path: string; message: string }[],
) => {
  const [showErrorModal, hideErrorModal] = useModal(
    () => (
      <Modal
        onRequestClose={hideErrorModal}
        shouldReturnFocusAfterClose
        shouldFocusAfterRender
        aria={{
          labelledby: "validation-errors-heading",
        }}
      >
        <ValidationErrorModalContent
          validationErrors={validationErrors}
          onClose={hideErrorModal}
        />
      </Modal>
    ),
    [validationErrors],
  );

  return [showErrorModal, hideErrorModal] as const;
};
